import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// API resource: tio-api app/resources/api/v1/accounting_return_resource.rb
const AccountingReturnSchema = withDefaults({
  type: 'accounting-return',
  fields: [
    { kind: 'attribute', name: 'amount' },
    { kind: 'attribute', name: 'state' },
    { kind: 'attribute', name: 'returnType' },
    { kind: 'attribute', name: 'reason' },
    { kind: 'attribute', name: 'notes' },
    { kind: 'attribute', name: 'uploadedCsv' },
    { kind: 'attribute', name: 'uploadedData' },
    {
      kind: 'belongsTo',
      name: 'accountingTransaction',
      type: 'accounting-transaction',
      options: { async: false, inverse: null },
    },
    {
      kind: 'belongsTo',
      name: 'employee',
      type: 'employee',
      options: { async: false, inverse: null },
    },
  ],
});

export default AccountingReturnSchema;
